import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import css from '../css/Addcase.module.css'
import { Link } from 'react-router-dom'
import Header from '../Components/Header'
import Rightcontainer from '../Components/Rightcontainer'
import Swal from 'sweetalert2'
import socket from '../Components/socket'
import { apiRequest } from '../store/allApi'

const Redeem = ({ walletUpdate }) => {
  const history = useHistory()

   // BASE URL
 
   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
   const nodeMode = process.env.NODE_ENV;
   if (nodeMode === "development") {
 
     var baseUrl = beckendLocalApiUrl;
   } else {
     baseUrl = beckendLiveApiUrl;
 }
 // +++++++++++++++++++++++++++++ 

  const [amount, setamount] = useState()
  const [userAllData, setUserAllData] = useState()
  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    try {
      const res = await apiRequest('me',"GET",null,headers)
      setUserAllData(res.data)
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('token')
      }
    }
  }

  useEffect(() => {
    let access_token = localStorage.getItem('token')
    access_token = localStorage.getItem('token')
    if (!access_token) {
      window.location.reload()
      history.push('/login')
    }
    role()
  }, [])

  const deposit =async () => {
    if (amount && amount >= 95 && amount <= 100000) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }

      try {
        const res = await apiRequest('referral/to/wallet',"POST",{amount},headers)
        if (res.data.msg === 'Invalid Amount') {
          Swal.fire({
            title: "You don't have sufficient amount",
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        } else {
          Swal.fire({
            title: 'success',
            icon: 'success',
            confirmButtonText: 'OK'
          })
        }
      } catch (e) {
        if (e?.response?.status == 401) {
          localStorage.removeItem('token')
          localStorage.removeItem('token')
          window.location.reload()
          history.push('/login')
        }
      }
    } else {
      let msg = 'Enter Amount'
      if (!amount) {
        msg = 'Enter Amount'
      } else if (95 <= amount <= 100000) {
        msg = 'Amount should be more than 95.'
      }
      Swal.fire({
        title: msg,
        icon: 'Error',
        confirmButtonText: 'OK'
      })
    }
  }

  return (
    <>
      <Header user={userAllData} />
      <div
        className='leftContainer mb_space'
        style={{ minHeight: '100vh', height: '100%' }}
      >
       <div className='refer-redeem-modern-card pb-5'>
             <div className='profile_headings mt-0 text-dark modern-redeem-title text-center'>
      <h4>Redeem your refer balance</h4> 
    </div>
        <div className='refer-box m-auto text-center'>
            <img className='w-50 mb-3' src="/images/refer-support.png"/>
        </div>
  {/* Header Section */}
  <div className='redeem-header'>
   
    <div className='tds-notice-box'>
      <i className="fa fa-info-circle"></i>
      <p className='commaon_para mb-0'>
        TDS (0%) will be deducted after annual referral earning of <span>₹15,000.</span>
      </p>
    </div>
  </div>

  {/* Input Section */}
  <div className='redeem-body-section'>
    <div className='input-container-premium'>
      <label className='input-helper-label'>Enter Amount (Min: 100, Max: 10000)</label>
      
      <div className='modern-input-wrapper'>
        <span className='input-icon-rupee'>₹</span>
        <div className='MuiFormControl-root MuiTextField-root mt-0 w-100'>
          <input
            className='commaon_input_box premium-redeem-input'
            type='number'
            value={amount}
            placeholder='0'
            onChange={e => setamount(parseInt(e.target.value))}
          ></input>
        </div>
      </div>

      <div className='min-withdraw-hint'>
        <p>
          Minimum withdrawal amount <span>₹95</span>
        </p>
      </div>
    </div>

    {/* Action Button */}
    <div className='add_cash_nest_btn mt-3'>
      <button
        className='modern-redeem-btn'
        onClick={() => deposit()}
      >
        Redeem Now
      </button>
    </div>
  </div>
</div>
      </div>
    </>
  )
}
export default Redeem
